import { render } from "./viewFile.vue?vue&type=template&id=40d4c054&scoped=true"
import script from "./viewFile.vue?vue&type=script&lang=js"
export * from "./viewFile.vue?vue&type=script&lang=js"

import "./viewFile.vue?vue&type=style&index=0&id=40d4c054&lang=scss"
import "./viewFile.vue?vue&type=style&index=1&id=40d4c054&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d4c054"]])

export default __exports__